import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'SIDEBAR', {
  CATEGORY_PRICES: 'Category prices',
  CEMENTERIES: 'Cementeries',
  DASHBOARD: 'Dashboard',
  DOCUMENTS: 'Documents',
  DOCUMENTS_CREATE: 'Create document',
  DOCUMENTS_TYPES: 'Documents types',
  PERSONS: 'Persons',
  PERSONS_LIST: 'Persons list',
  PERSONS_STATES: 'Persons states',
  PROCEDURES: 'Procedures',
  EMAILS: 'Emails',
  USERS: 'Usuarios',
  USERS_LIST: 'Users list',
  USERS_ROLES: 'Roles',
  USERS_PERMISSIONS: 'Permissions',
  PUBLIC_PROCEDURE_HOME: 'Home',
  PUBLIC_PROCEDURES: 'Procedures',
  PUBLIC_PROCEDURE_MARRIAGE: 'Marriage procedure',
  PUBLIC_PROCEDURE_DIVORCE: 'Divorce procedure',
  PUBLIC_PROCEDURE_JEWISHNESS: 'Jewishness procedure',
  PUBLIC_PROCEDURE_DEATH: 'Death procedure',
  PUBLIC_PROCEDURE_RESERVATION: 'Reservation procedure',
  PUBLIC_PROCEDURE_MATZEVA: 'Matzeva procedure',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'SIDEBAR', {
  CATEGORY_PRICES: 'Precios de categoría',
  CEMENTERIES: 'Cementerios',
  DASHBOARD: 'Dashboard',
  DOCUMENTS: 'Documentos',
  DOCUMENTS_CREATE: 'Crear documento',
  DOCUMENTS_TYPES: 'Tipos de documentos',
  PERSONS: 'Personas',
  PERSONS_LIST: 'Listado de personas',
  PERSONS_STATES: 'Estados de personas',
  PROCEDURES: 'Trámites',
  EMAILS: 'Emails',
  USERS: 'Usuarios',
  USERS_LIST: 'Listado de usuarios',
  USERS_ROLES: 'Roles',
  USERS_PERMISSIONS: 'Permisos',
  PUBLIC_PROCEDURE_HOME: 'Inicio',
  PUBLIC_PROCEDURES: 'Trámites',
  PUBLIC_PROCEDURE_MARRIAGE: 'Trámite de casamiento',
  PUBLIC_PROCEDURE_DIVORCE: 'Trámite de divorcio',
  PUBLIC_PROCEDURE_JEWISHNESS: 'Certificado de judeidad',
  PUBLIC_PROCEDURE_DEATH: 'Trámite de fallecimiento',
  PUBLIC_PROCEDURE_RESERVATION: 'Trámite de reserva',
  PUBLIC_PROCEDURE_MATZEVA: 'Trámite de matzeva',
});
